import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "data-testid": "calibration-due-at" }

import dayjs from 'dayjs'
import { computed, ref, watch } from 'vue'
import { UiFormField, UiInput, UiButton } from '@klausapp/ui-kit'
import DayPicker from '@/components/pickers/DayPicker.vue'

import QModal from '@/components/QModal.vue'
import { session } from '@/composables/useSession'
import {
  createCalibrationSession,
  editCalibrationSession,
  type CalibrationSession,
  type EditCalibrationSessionPayload,
} from '@/api/calibration'
import { track } from '@/utils/analytics'


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateCalibrationSession',
  props: {
    active: { type: Boolean },
    show: { type: Boolean },
    edit: {}
  },
  emits: ["close", "update"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const getToday = () => dayjs().format()
const name = ref('')
const dueAt = ref(getToday())

const submit = async () => {
  if (!name.value && !dueAt.value) return

  if (props.edit) {
    const calibrationSession: EditCalibrationSessionPayload = {}

    if (name.value !== props.edit?.title) calibrationSession.title = name.value
    if (!dayjs(dueAt.value).isSame(props.edit?.dueAt, 'day') && !dayjs(dueAt.value).isBefore(undefined, 'day'))
      calibrationSession.dueAt = dueAt.value

    await editCalibrationSession(session.workspace.id, props.edit.sessionId, calibrationSession)
    track('Calibration session edited', { type: props.active ? 'active' : 'old' })
  } else {
    await createCalibrationSession(session.workspace.id, { title: name.value, dueAt: dueAt.value })
    track('Calibration session created', { type: props.active ? 'active' : 'old' })
  }

  emit('update')
  emit('close')
}

const canSubmit = computed(() => {
  const canCreateSession = !!name.value.trim() && !!dueAt.value
  const canUpdateSession =
    (!!name.value.trim() && name.value !== props.edit?.title) ||
    (!!dueAt.value &&
      !dayjs(dueAt.value).isSame(props.edit?.dueAt, 'day') &&
      !dayjs(dueAt.value).isBefore(undefined, 'day'))

  return props.edit ? canUpdateSession : canCreateSession
})

watch(
  () => props.show,
  (show: boolean) => {
    if (!show) {
      name.value = ''
      dueAt.value = getToday()
    }
  },
)

watch(
  () => props.edit,
  (edit) => {
    if (edit) {
      name.value = edit.title
      dueAt.value = edit.dueAt
    }
  },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(QModal, {
    show: _ctx.show,
    title: _ctx.$t(`conversations.filters.calibrations.create_modal.${_ctx.edit ? 'edit_' : ''}title`),
    "close-button": "",
    narrow: "",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
  }, {
    actions: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.buttons)
      }, [
        _createVNode(_unref(UiButton), {
          secondary: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('universal.cancel')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_unref(UiButton), {
          "data-testid": "create-session-btn",
          type: "submit",
          disabled: !canSubmit.value,
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.edit ? 'universal.save_changes' : 'conversations.filters.calibrations.create_modal.submit')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled"])
      ], 2 /* CLASS */)
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        "data-testid": "calibration-form",
        class: _normalizeClass(_ctx.$style.form),
        onSubmit: _withModifiers(submit, ["prevent"])
      }, [
        _createVNode(_unref(UiFormField), {
          label: _ctx.$t('conversations.filters.calibrations.create_modal.name_label'),
          class: _normalizeClass(_ctx.$style.nameField)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(UiInput), {
              modelValue: name.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
              "data-testid": "calibration-form-name",
              name: "name",
              required: "",
              maxlength: "255"
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "class"]),
        _createVNode(_unref(UiFormField), {
          label: _ctx.$t('conversations.filters.calibrations.create_modal.date_label')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(DayPicker, {
                modelValue: dueAt.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dueAt).value = $event)),
                "min-date": new Date()
              }, null, 8 /* PROPS */, ["modelValue", "min-date"])
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"])
      ], 34 /* CLASS, NEED_HYDRATION */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show", "title"]))
}
}

})